/* eslint-disable max-len */
/* eslint-disable react/jsx-closing-bracket-location */
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import React, { Component } from 'react';
import { CommaSeparator, GetFormat, getFirstDueInstallmentAndNext } from '../../AppUtil/AppUtil';

import Button from '@material-ui/core/Button';
import Swal from 'sweetalert2';

import Loader from '../Common/Loader';

import moment from 'moment';
import { withTranslation } from 'react-i18next';

const APP_IMAGES = window.AppConfig.APP_IMAGES;

class SkipPayment extends Component {
	constructor(props) {
		super(props);

		this.state = {
			id: ''
		};
	}

	genrateButton = (name, action) => {
		return (
			<Grid className="no-shadow" container id="reduce-width" justify="center" spacing={2}>
				<Grid id="shadow-round" item sm={8} spacing={2} xs={12}>
					<Button
						aria-label="add"
						className="back-btn-large-review btn-green"
						fullWidth
						onClick={action}
						// style={{ backgroundColor: 'darkblue', color: 'white' }}
						type="submit"
						variant="extended">
						{this.props.t(name)}
					</Button>
				</Grid>
			</Grid>
		);
	};

	toastWhenSkipAndExtend = () => {
		Swal.fire({
			title: this.props.t('sweetalert_title.are_you_sure_skip_payment_and_extend_loan'),
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			confirmButtonText: this.props.t('buttons.yes'),
			customClass: 'otp_message_success'
		}).then(result => {
			if (result.value) {
				this.props.paymentAction(
					'SKIP_AND_EXTEND',
					this.skipAndExtend,
					this.toastSomethingWentWrong,
					this.state.id
				);
			}
		});
	};

	toastWhenSkipAndAdd = () => {
		Swal.fire({
			title: this.props.t('sweetalert_title.are_you_sure_skip_payment_and_add_to_next_payment'),
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			confirmButtonText: this.props.t('buttons.yes'),
			customClass: 'otp_message_success'
		}).then(result => {
			if (result.value) {
				this.props.paymentAction('SKIP_AND_ADD', this.skipAndAdd, this.toastSomethingWentWrong, this.state.id);
			}
		});
	};

	skipAndExtend = () => {
		Swal.fire({
			animation: false,
			title: this.props.t('label.success'),
			text: this.props.t('app_message.you_have_successfully_skipped_and_extended_the_loan'),
			icon: 'success',
			customClass: 'otp_message_success'
		});
	};

	skipAndAdd = () => {
		Swal.fire({
			animation: false,
			title: this.props.t('label.success'),
			text: this.props.t('app_message.you_have_successfully_skipped_and_added_the_installment_to_next_payment'),
			icon: 'success',
			customClass: 'otp_message_success'
		});
	};

	// Define the function to get all the lapses installments and calculate total emi_amount
	getLapsesInstallmentsAmount = installments => {
		const today = new Date();
		today.setHours(0, 0, 0, 0); // Set the time to midnight

		// Filter the installments with state set to 'DUE' and invalid date
		const lapsesInstallments = installments.filter(installment => {
			// Check if the installment date is valid and in the past
			const installmentDate = new Date(installment.installment_date);

			return installment.state === 'DUE' && installmentDate < today;
		});

		// Calculate the total emi_amount for lapses installments
		const totalLapsesAmount = lapsesInstallments.reduce(
			(acc, installment) => acc + Number(installment.emi_amount),
			0
		);

		// Return the total emi_amount for lapses installments
		return totalLapsesAmount;
	};

	isLeapYear(year) {
		return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	}

	setNextDateByFrequency(date, persistDay, frequency) {
		date = new Date(new Date(date).setUTCHours(0, 0, 0, 0));

		switch (frequency) {
			case 'MONTH':
				if (date.getMonth() === 0 && Number(persistDay) > 28) {
					// Check for leap year before setting the date
					const year = date.getFullYear();
					if (this.isLeapYear(year)) {
						date.setDate(29); // Set February to 29 days in a leap year
					} else {
						date.setDate(28); // Set February to 28 days in a non-leap year
					}
					date.setMonth(1); // Set month to February (index 1)
				} else {
					if (Number(persistDay) === 31) {
						// Set the date to the first day of the current month
						date.setDate(1);
						// Add 2 months to the date
						date.setMonth(date.getMonth() + 2);
						// Subtract one day to get the last day of the previous (next) month
						date.setDate(date.getDate() - 1);
					} else {
						date.setMonth(date.getMonth() + 1);
						date.setDate(Number(persistDay) || date.getDate());
					}
				}

				break;
			case 'WEEK':
				// Add 7 days
				date.setDate(date.getDate() + 7);
				break;
			case 'TWO WEEK':
				// Add 14 days
				date.setDate(date.getDate() + 14);
				break;
			default:
				break;
		}
		return new Date(new Date(date).setUTCHours(0, 0, 0, 0));
	}

	getEndDateByInstallments = (noOfInstallments, firstInstallmentDate, frequency) => {
		console.log({ firstInstallmentDate });
		let endDate = new Date(firstInstallmentDate);
		console.log({ endDate });
		let persistDay = 0;

		for (let i = 0; i < noOfInstallments - 1; i++) {
			// for persisting the day of the month, workaround for the month of february.
			if (endDate.getDate() > 28 && i === 0) {
				persistDay = endDate.getDate();
			}

			endDate = this.setNextDateByFrequency(endDate, persistDay, frequency);
		}

		return GetFormat(endDate);
	};

	// Define the function to get selected installment data
	getSkipAndExtendInstallments = () => {
		// Get the loan object from props
		const loanObject = this.props.loanObject;
		// Get the installments from the loan object, or default to an empty array if it doesn't exist
		const installments = loanObject?.installments || [];

		// Initialize variables for the installment date, next installment date, and current installment ID
		let installmentDate;
		let lastInstallmentDate;
		let currentInstallmentId;

		// Get the first due installment
		const { firstDueInstallment, nextInstallment } = getFirstDueInstallmentAndNext(installments);

		// If a 'DUE' installment is found
		if (firstDueInstallment) {
			installmentDate = GetFormat(nextInstallment.installment_date);
			// Get the ID of the first due installment
			currentInstallmentId = firstDueInstallment.id;

			// Get the last item in the installments array
			lastInstallmentDate = this.getEndDateByInstallments(
				loanObject.no_of_installments + 1,
				loanObject.first_installment_date,
				loanObject.frequency
			);
		}

		// Return an object with the installment date, next installment date, and current installment ID
		return {
			installmentDate,
			lastInstallmentDate,
			currentInstallmentId
		};
	};

	// Define the function to get selected installment data
	getSkipAndAddInstallments = () => {
		// Get the loan object from props
		const loanObject = this.props.loanObject;
		// Get the installments from the loan object, or default to an empty array if it doesn't exist
		const installments = loanObject?.installments || [];

		// Initialize variables for the installment date, next installment date, and current installment ID
		let installmentDate;
		let currentInstallmentId;
		let amount;

		// Get the first due installment
		const { firstDueInstallment, nextInstallment } = getFirstDueInstallmentAndNext(installments);

		// If a 'DUE' installment is found
		if (firstDueInstallment) {
			// Format the date of the first due installment
			installmentDate = GetFormat(nextInstallment.installment_date);
			// Get the ID of the first due installment
			currentInstallmentId = firstDueInstallment.id;
			// Get the amount of the first due installment;

			amount = CommaSeparator(+firstDueInstallment.emi_amount + +nextInstallment.emi_amount);
		}

		// Return an object with the installment date, next installment date, and current installment ID
		return {
			installmentDate,
			amount,
			currentInstallmentId
		};
	};

	genrateSkipAndExtendTxt = () => {
		const { installmentDate, lastInstallmentDate, currentInstallmentId } = this.getSkipAndExtendInstallments();
		// Check if the current state is different from the new state value
		if (this.state.id !== currentInstallmentId) {
			this.setState({
				id: currentInstallmentId
			});
		}

		// const interpolationObject = {
		// 	next_payment_date: installmentDate,
		// 	extended_date: lastInstallmentDate
		// };

		return (
			<>
				The Next Payment Date will be <strong> {installmentDate} </strong> and Final Payment Date is Extended to{' '}
				<strong>{lastInstallmentDate}</strong>.
			</>
		);
	};

	genrateSkipAndAddTxt = () => {
		const { installmentDate, amount, currentInstallmentId } = this.getSkipAndAddInstallments();
		// Check if the current state is different from the new state value
		if (this.state.id !== currentInstallmentId) {
			this.setState({
				id: currentInstallmentId
			});
		}

		// const interpolationObject = {
		// 	next_payment_date: installmentDate,
		// 	amount
		// };
		// return this.props.t('app_message.next_payment_date_and_payment_amount_will_be', interpolationObject);
		return (
			<>
				The Next Payment Date will be <strong> {installmentDate} </strong> and Payment Amount will be{' '}
				<strong>{amount}</strong>.
			</>
		);
	};

	isLastInstallment() {
		const loanObject = this.props.loanObject;
		const currentInstallment = loanObject.next_installment_details;
		return moment(currentInstallment?.installment_date).diff(moment(loanObject.end_date), 'days') === 0;
	}

	toastSomethingWentWrong = () => {
		Swal.fire({
			title: this.props.t('sweetalert_title.error'),
			text: this.props.t('error_message.something_went_wrong'),
			imageUrl: 'https://cdn-icons-png.flaticon.com/512/5219/5219070.png',
			imageAlt: 'Custom Image',

			// icon: 'error',
			confirmButtonText: this.props.t('buttons.try_again'),
			customClass: 'otp_message_success'
		});
	};

	render() {
		const { t } = this.props;

		console.log({ t });

		console.log(this.props.loanObject);
		return (
			<section>
				<Container component="main" maxWidth="md">
					<div>
						<Grid container id="reduce-width" justify="center" spacing={5}>
							<Grid id="shadow-round" item sm={8} spacing={2} xs={12}>
								<Grid container id="padding-20" spacing={2}>
									<Grid
										className="no-shadow"
										container
										id="reduce-width"
										justify="center"
										spacing={2}>
										<Grid item sm={8} xs={12}>
											<img
												alt="Invite"
												className="img-reponsive"
												src={APP_IMAGES.SKIP_PAYMENT}
												style={{ maxWidth: '100%', maxHeight: 'initial' }}
											/>
											<h4 className="text-center">{t('label.skip_payment')}</h4>
										</Grid>
									</Grid>
									<Grid
										className="no-shadow"
										container
										id="reduce-width"
										justify="center"
										spacing={2}>
										<Grid id="shadow-round" item sm={8} spacing={2} xs={12}>
											<h5 className="text-center">{t('label.do_you_want_to')}</h5>
										</Grid>
									</Grid>
									{this.props.type === 'SKIP&EXTEND' && (
										<>
											{this.genrateButton(
												'buttons.skip_payement_and_extend_loan',
												this.toastWhenSkipAndExtend
											)}
											<Grid
												className="no-shadow"
												container
												id="reduce-width"
												justify="center"
												spacing={2}>
												<Grid id="shadow-round" item sm={8} spacing={2} xs={12}>
													<p className="text-center">{this.genrateSkipAndExtendTxt()}</p>
												</Grid>
											</Grid>
										</>
									)}

									{this.props.type === 'SKIP&ADD' && (
										<>
											{this.genrateButton(
												'buttons.skip_payment_and_add_to_next_payment',
												this.toastWhenSkipAndAdd
											)}
											<Grid
												className="no-shadow"
												container
												id="reduce-width"
												justify="center"
												spacing={2}>
												<Grid id="shadow-round" item sm={8} spacing={2} xs={12}>
													<p className="text-center">{this.genrateSkipAndAddTxt()}</p>
												</Grid>
											</Grid>
										</>
									)}

									<Grid
										className="no-shadow"
										container
										id="reduce-width"
										justify="center"
										spacing={2}>
										<Grid id="shadow-round" item sm={8} spacing={2} xs={12}>
											<Button
												aria-label="add"
												className="back-btn-large-review"
												fullWidth
												id="forgive-back"
												onClick={this.props.onBack}
												// style={{ backgroundColor: 'darkblue', color: 'white' }}
												type="submit"
												variant="extended">
												{t('buttons.back')}
											</Button>
										</Grid>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</div>
				</Container>
				{this.props.isLoading ? <Loader /> : ''}
			</section>
		);
	}
}

export default withTranslation()(SkipPayment);
